import React, { useEffect, useRef, useState } from 'react';
import { Animated, Platform, StyleProp, ViewStyle } from 'react-native';
import { ANIMATED_OPACITY_DURATION_MS } from '@/constants';

interface Props {
  children: React.ReactNode;
  isVisible: boolean;
  style?: StyleProp<ViewStyle>;
}

export const FadingComponent: React.FC<Props> = ({
  isVisible,
  children,
  style,
}) => {
  const opacityValue = useRef(new Animated.Value(isVisible ? 1 : 0));
  const [internalVisible, setInternalVisible] = useState(isVisible);

  useEffect(() => {
    if (isVisible) {
      setInternalVisible(true);
    }
    Animated.timing(opacityValue.current, {
      duration: ANIMATED_OPACITY_DURATION_MS,
      toValue: isVisible ? 1 : 0,
      useNativeDriver: Platform.OS !== 'web',
    }).start(() => {
      setInternalVisible(isVisible);
    });
  }, [isVisible]);

  if (!internalVisible) {
    return null;
  }

  return (
    <Animated.View style={[style, { opacity: opacityValue.current }]}>
      {children}
    </Animated.View>
  );
};
